export const maintenanceSending = {
    sendVehicle(params) {
        let url;

        if(params.vin){
            url = `/api/form/${params.brandId}/service/catalog/vin/${params.vin}?mileage=${params.mileage}`
        } else {
            url = `/api/form/${params.brandId}/service/catalog/vin/?mileage=${params.mileage}`
                + `&model=${params.model}&air_type=${params.airType}&fuel_type=${params.fuelType}`
                + `&engine_capacity=${params.engineCapacity}&model_year=${params.modelYear}`
        }

        return url;
    },

    sendServicePackages(params) {
        const url = `/api/form/${params.brandId}/service/send_packages`;
        return url;
    },

    sendTimeSlot(params) {
        const url = `/api/form/${params.brandId}/service/send_booking`;
        return url;
    },

    sendClientInfo(params) {
        const url = `/api/form/${params.brandId}/service/contact`;
        return url;
    },

    confirm(params) {
        const url = `/api/form/${params.brandId}/service/confirm`;
        return url;
    }
};



// WEBPACK FOOTER //
// ./src/urlConstructor/maintenanceSending.js